import { Redirect } from "expo-router"
import { loanAppDashboardPath } from "@/screens/loans/utils/LoanUtils"
import { useLoanContext } from "@/screens/loans/components/LoanContext"

export default function Index() {
  const { loanId } = useLoanContext()
  return <Redirect href={loanAppDashboardPath(loanId)} />
}
